import toCSV from './toCSV'

/**
 * Zet rijen om naar CSV en start de download in de browser.
 *
 * De BOM vooraan zorgt dat Excel het bestand als UTF-8 leest; zonder die
 * markering maakt Excel van 'ë' twee vreemde tekens.
 *
 * @param {Array<Record<string, any>>} rows - De rijen om te exporteren
 * @param {string} filename - Bestandsnaam inclusief .csv
 * @param {string[]} [headerOrder] - Gewenste kolomvolgorde
 * @returns {boolean} false wanneer er niets te exporteren viel
 */
const downloadCSV = (rows, filename, headerOrder) => {
    const csv = toCSV(rows, headerOrder)
    if (!csv) return false

    const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.click()

    // Pas later vrijgeven, zodat Safari en Firefox de download kunnen starten.
    setTimeout(() => URL.revokeObjectURL(url), 1000)

    return true
}

export default downloadCSV
